module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-title onepx-b"
  }, [_c('span', {
    staticClass: "title-name"
  }, [_vm._v(_vm._s(_vm.titleText.title))]), _vm._v(" "), _c('div', {
    staticClass: "right-nav",
    on: {
      "click": _vm.goListPage
    }
  }, [_c('span', {
    staticClass: "right-nav-text"
  }, [_vm._v(_vm._s(_vm.titleText.extend))]), _vm._v(" "), _c('i', {
    staticClass: "iconfont icon-gengduo"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-7da22210"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/homePageLists/list-title.vue
// module id = 847
// module chunks = 39